var React = require('react');

module.exports = function () {
  return /*#__PURE__*/React.createElement("svg", {
    className: "symbol symbol-addressBarMiniToolbar",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 60",
    width: "160",
    height: "60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c1",
    fillRule: "evenodd",
    d: "M128.92 29.04l10.69-10.19a18.234 18.234 0 0 0-12.62-5.04c-9.87 0-17.91 7.65-17.91 17.07 0 9.41 8.04 17.07 17.91 17.07 7.71 0 14.23-4.68 16.76-11.2h10.4c-2.81 11.84-13.89 20.69-27.16 20.69-15.38 0-27.86-11.89-27.86-26.56 0-14.67 12.48-26.56 27.86-26.56 7.7 0 14.61 3.02 19.64 7.84l10.15-9.68v26.56h-27.86zm-73.86 7.74H23.25l9.73 9.27c2.33 2.22 2.33 5.82 0 8.05-2.33 2.22-6.11 2.22-8.45 0L4.98 35.46c-.11-.09-.26-.13-.36-.23a5.492 5.492 0 0 1-1.74-4.08c-.02-1.48.55-2.96 1.74-4.09.1-.1.25-.13.36-.23L24.53 8.19c2.34-2.22 6.12-2.22 8.45 0 2.33 2.23 2.33 5.83 0 8.05l-9.61 9.16h31.69c3.3 0 5.97 2.54 5.97 5.69 0 3.14-2.67 5.69-5.97 5.69z"
  }));
};